(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const track = (eventName, parameters) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: eventName,
      event_parameters: parameters
    });
  };

  const observeInview = (root) => {
    if (!root || root.classList.contains("si26-is-inview")) return;

    if (reduceMotion.matches || typeof IntersectionObserver === "undefined") {
      root.classList.add("si26-is-inview");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("si26-is-inview");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
    );

    observer.observe(root);
  };

  const observeOnce = (element, onVisible) => {
    if (!element || element.dataset.si26Impressed === "true") return;
    const fire = () => {
      if (element.dataset.si26Impressed === "true") return;
      element.dataset.si26Impressed = "true";
      onVisible();
    };
    if (typeof IntersectionObserver === "undefined") {
      fire();
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          fire();
          observer.disconnect();
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(element);
  };

  const initCards = (root) => {
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";
    observeInview(root);
    observeOnce(root, () => {
      track("module_impression", { module: "insta&shokz_website" });
    });
    root.querySelectorAll(".si26-cards__cta").forEach((link) => {
      link.addEventListener("click", () => {
        const card = link.closest(".si26-cards__card");
        track("select_content", {
          content_type: "insta&shokz_website",
          content_name: card?.dataset.si26TrackContent || "",
          button_name: card?.dataset.si26TrackButton || ""
        });
      });
    });
  };

  const init = (scope = document) => {
    if (scope.matches?.("[data-si26-cards]")) {
      initCards(scope);
    }
    scope.querySelectorAll?.("[data-si26-cards]").forEach(initCards);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
